// Extracts the event ID from a given pathname (e.g., /events/123/photos → "123")
export const getEventIdFromPath=(pathname) =>{
  if (!pathname || typeof pathname !== "string") return null;

  const pathParts = pathname.split("/").filter(Boolean); // removes empty strings
  if ((pathParts[0] === "events" || pathParts[0] === "verify" ) && pathParts.length > 1) {
    return pathParts[1];
  }

  return null;
}